import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { signupCopy } from '@/Pages/Signup/copy';
import '@/Pages/Signup/SignupPage.sass';

export function SignupHeader(): JSX.Element {
  return (
    <Box
      component="header"
      className="signup-header"
      data-testid="signup-header"
    >
      <Typography
        component="p"
        variant="overline"
        className="signup-header__identity"
      >
        {signupCopy.productName}
      </Typography>

      <Typography component="h1" variant="h5" className="signup-header__title">
        {signupCopy.title}
      </Typography>

      <Typography component="p" variant="body2" className="signup-header__subtitle">
        {signupCopy.subtitle}
      </Typography>
    </Box>
  );
}
